import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import {
  ShiftManagementRolesRequirementsFragment,
  ShiftManagementTreeRolesRequirementsFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import AddButton from 'modules/shift_management/components/ShiftManagement/AddButton'
import { usePermissions } from 'modules/shift_management/hooks/usePermissions'
import { Shift } from 'modules/shift_management/lib/types'
import type UnassignedShift from 'modules/shift_management/store/internal/models/UnassignedShift'
import type PlannedBreaks from 'modules/time_planning/store/internal/collections/plannedBreaks'

import AddUnassignedShiftModal from './AddUnassignedShiftModal'
import UnassignedShiftItem from './UnassignedShiftItem'

const UnassignedShiftsList = ({
  date,
  unassignedShifts,
  shiftsByDate,
  plannedBreaks,
  roles,
  treeRoles,
}: {
  date: moment.Moment
  unassignedShifts: UnassignedShift[]
  shiftsByDate: Shift[]
  plannedBreaks: PlannedBreaks
  roles: ShiftManagementRolesRequirementsFragment[]
  treeRoles: ShiftManagementTreeRolesRequirementsFragment[] | undefined
}) => {
  const [openAddShiftModal, setOpenAddShiftModal] = React.useState<boolean>(false)
  const [
    {
      canCreateUnassignedShiftsForEverybody,
      canCreateUnassignedShiftsForTeam,
      canCreateUnassignedShiftsForReportees,
    },
  ] = usePermissions()

  const onCloseAddShiftModal = () => {
    setOpenAddShiftModal(false)
  }

  const onOpenAddShiftModal = () => {
    track(trackingEvents.shiftManagement.addUnassignedShiftStart, {})
    setOpenAddShiftModal(true)
  }

  const canCreateUnassignedShift =
    canCreateUnassignedShiftsForEverybody ||
    canCreateUnassignedShiftsForTeam ||
    canCreateUnassignedShiftsForReportees

  return (
    <Box flexDirection="column" height="full" width="full">
      {unassignedShifts.map((unassignedShift: UnassignedShift) => (
        <Box key={unassignedShift.id} flexDirection="column" width="full" paddingBottom="s4">
          <UnassignedShiftItem
            unassignedShift={unassignedShift}
            shiftsByDate={shiftsByDate}
            plannedBreaks={
              unassignedShift.defaultShiftId
                ? plannedBreaks.filterByDefaultShift(unassignedShift.defaultShiftId)
                : []
            }
            roles={roles}
            treeRoles={treeRoles}
          />
        </Box>
      ))}
      {canCreateUnassignedShift && <AddButton onClick={onOpenAddShiftModal} />}
      {openAddShiftModal && (
        <AddUnassignedShiftModal date={date} onClose={onCloseAddShiftModal} roles={roles} />
      )}
    </Box>
  )
}

export default observer(UnassignedShiftsList)
